import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0" style={{ fontFamily: "var(--font-heading)" }}>
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mt-6">页面不存在</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500">该爆料内容可能已被删除或链接有误</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-bold hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}